import { atom } from 'jotai';
import { SundVaegtProgramDto } from '@/shared/interfaces/api/sundvaegt-interfaces';
import { formatNumber } from '@/shared/helpers/formatNumber';
import { Utils } from '@/shared/Utils';
import {
    WeightLogCardType,
    WeightLogsUI,
} from '@/features/programs/widgets/sundvaegt/model/types';
import { fetchSundVaegtProgramQueryAtom } from './fetchSundVaegtProgramQueryAtom';
import { createWeightLogCards } from '../lib/helpers';

export const weightLogsAtom = atom<WeightLogsUI | null>((get) => {
    const program: SundVaegtProgramDto = get(
        fetchSundVaegtProgramQueryAtom,
    ).data;
    if (!program || program.WeightLogs.length < 1) return null;

    // Sort logs descending by date
    const sortedLogs = [...program.WeightLogs].sort(
        (a, b) => new Date(b.Date).getTime() - new Date(a.Date).getTime(),
    );

    const initialWeight = sortedLogs[0].WeightKg;
    const formattedTotalWeightLossGoal = program.DesiredWeightKg
        ? `${formatNumber(initialWeight - program.DesiredWeightKg)} kg`
        : undefined;

    const cards: WeightLogCardType[] = createWeightLogCards(
        sortedLogs,
        initialWeight,
        formattedTotalWeightLossGoal,
    );

    return { cards };
});
